import { Routes } from '@angular/router';
import { authenticationGuard } from './guards/auth.guard';
import { clientGuard } from './guards/client.guard';

export const appRoutes: Routes = [
    {
        path: '',
        canActivate: [authenticationGuard, clientGuard],
        loadChildren: () => import('./pages/tabs/tabs.routes').then(m => m.TABS_ROUTES),
    },
    {
        path: 'login',
        loadChildren: () => import('./pages/login/login.routes').then(m => m.LOGIN_ROUTES),
    },
    {
        path: 'onboarding',
        loadChildren: () => import('./onboarding.routes').then(m => m.ONBOARDING_ROUTES),
    },
];
